module.exports = __webpack_public_path__ + "static/media/Resume-of-Rhett-Williams.e131114e.pdf";